import { makeStyles } from "@material-ui/core/styles";
import { FONTS } from "../../emotion-theme";

export const useBreadcrumbsStyles = makeStyles(() => ({
  breadcrumbs: {
    margin: "10px 0 0 32px",
    fontFamily: FONTS.primary,
    color: "navyBlue",
    fontSize: "10px",
    minHeight: "17px",
  },
}));
